import { useRef, useState } from "react";
import { Tooltip } from "@fluentui/react-components";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import PropTypes from "prop-types";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import { ExportHistoricalData, getStafferMemberProjectsTracker, getStafferMemberTracker, handleStafferMemberTrackerExport, mapPowerExportData, sortMembersByRoleAndCapacity, sortProjectsByStatus } from "../dashboard-pui-banker/power-banker-time-log/power-banker-helper";
import DownloadHistoricalDataModal from "./download-historical-data-modal";

const DashboardPowerMemberTrackerHeader = ({ members, resetDataState, memberState }) => {
    const _juniorBankersExport = useRef(null);
    const _memberProjectsExport = useRef(null);
    const sortedMembers = sortMembersByRoleAndCapacity(members);
    const projects = members?.map(item => item.Projects.map(b => ({ ...b, Banker: item.Banker }))).flat() || [];
    const sortedProjects = sortProjectsByStatus(projects);
    const transformedProjects = mapPowerExportData(sortedProjects);
    const [viewDataModal, setViewDataModal] = useState(false);
    const hasAnyFilter =
        memberState.filter &&
        Array.isArray(memberState.filter.filters) &&
        memberState.filter.filters.length > 0;
    const canReset = memberState.sort.length > 0 || hasAnyFilter;

    return (
        <>
            <div className="widget-header" data-testid="header">
                <div className="header-left">
                    <div className="main-title-badge-row">
                        <div className="main-title">Time Tracker</div>
                    </div>
                    <div className="sub-title">GIB/PU&I</div>
                </div>
                <div className="header-right">
                    <Tooltip content="Reset Filters and Sorting">
                        <FluentButton
                            appearance="secondaryWithOutline"
                            icon={
                                <FluentUiIcon
                                    name="ArrowResetRegular"
                                    color={canReset ? "#0F6CBD" : "#A0A0A0"}
                                    size={20}
                                    disabled={!canReset}
                                />
                            }
                            disabled={!canReset}
                            onClick={resetDataState}
                        />
                    </Tooltip>
                    <FluentButton
                        icon={<FluentUiIcon name={'CalendarArrowCounterclockwiseRegular'} color={'#0F6CBD'} size={20} />}
                        text="Historical Data"
                        onClick={() => setViewDataModal(true)}
                    />
                    {members?.length > 0 &&
                        <Tooltip content="Export Data">
                            <FluentButton
                                appearance="secondaryWithOutline"
                                icon={
                                    <FluentUiIcon
                                        name="ArrowDownloadRegular"
                                        color="#0F6CBD"
                                        size={20}
                                    />
                                }
                                onClick={() =>
                                    handleStafferMemberTrackerExport({ _juniorBankersExportRef: _juniorBankersExport, _memberProjectsExportRef: _memberProjectsExport })
                                }
                            />
                        </Tooltip>
                    }
                </div>
            </div>
            <ExcelExport data={sortedMembers} ref={_juniorBankersExport}>
                {getStafferMemberTracker()}
            </ExcelExport>
            <ExcelExport data={transformedProjects} ref={_memberProjectsExport}>
                {getStafferMemberProjectsTracker()}
            </ExcelExport>
            {viewDataModal &&
                <DownloadHistoricalDataModal
                    open={viewDataModal}
                    OnCancel={() => setViewDataModal(false)}
                    OnDownloadData={(startDate, endDate) =>
                        ExportHistoricalData(startDate, endDate)
                    }
                />
            }
        </>
    );
};

DashboardPowerMemberTrackerHeader.propTypes = {
    members: PropTypes.array,
    resetDataState: PropTypes.func,
    memberState: PropTypes.object,
};

export default DashboardPowerMemberTrackerHeader;